module.exports = __webpack_public_path__ + "img/phone-img.b71cd7c1.png";